
  import { Vue, Component, Prop } from "vue-property-decorator";

  import { NO_INFORMATION } from "@/data/placeholders";

  @Component({})
  export default class InformationCard extends Vue {
    @Prop({ type: String, default: "" }) readonly title!: string;
    @Prop({ type: [String, Number], default: undefined }) readonly content!: string | number | undefined;
     @Prop({ type: [String, Number], default: undefined }) readonly total!: string | number | undefined;
    @Prop({ type: String, default: undefined }) readonly prefix!: string | undefined;
    @Prop({ type: String, default: "px-6" }) readonly contentHorizontalPadding!: string | undefined;

    placeholder: string = NO_INFORMATION;
  }
